import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, Project } from '../../models';
import { UserProjectLists } from '../logic-services/models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class ProjectsDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getAllUserProjects(app: App): Observable<UserProjectLists> {
        const url = `${this.route}${app.id}/projects`;
        return this.httpGet(url);
    }

    saveDraft(app: App, project: Project): Observable<Project> {
        const url = `${this.route}${app.id}/projects/${project.id}/layoutDraft`;
        return this.httpPut(url, project);
    }

    publishProject(app: App, project: Project): Observable<Project> {
        const url = `${this.route}${app.id}/projects/${project.id}/JSONForms,layoutDraft`;
        return this.httpPut(url, project);
    }

    updateProject(app: App, project: Project): Observable<Project> {
        const url = `${this.route}${app.id}/projects/${project.id}`;
        return this.httpPut(url, project);
    }

    updateProjectWithFilter(app: App, project: Project, filter: string[]): Observable<Project> {
        const url = `${this.route}${app.id}/projects/${project.id}/${filter}`;
        return this.httpPut(url, project);
    }

    updateProjectOrders(app: App, orderByProjectId: Record<string, number>): Observable<Project[]> {
        const url = `${this.route}${app.id}/projects/reorder`;
        return this.httpPut(url, orderByProjectId);
    }

    createProject(app: App, project: Project): Observable<Project> {
        const url = `${this.route}${app.id}/projects`;
        return this.httpPost(url, project);
    }

    exportLayout(app: App, project: Project): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/layout`;
        return this.httpDownload(url);
    }

    uploadLayout(app: App, project: Project, formData: FormData): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/layout`;
        return this.httpPost(url, formData);
    }

    createSummaryProject(app: App, project: Project): Observable<Project> {
        const url = `${this.route}${app.id}/summary-project`;
        return this.httpPost(url, project);
    }

    updateSummaryProject(app: App, project: Project): Observable<Project> {
        const url = `${this.route}${app.id}/summary-project`;
        return this.httpPut(url, project);
    }

    deleteSummaryProject(app: App): Observable<void> {
        const url = `${this.route}${app.id}/summary-project`;
        return this.httpDelete(url);
    }
}
